export const onCheckBoxClick = (data) => {
  return {
    type: "Click_Checkbox",
    payload: data,
  };
};

export const ON_SELECTED_QUANTITY_ITEM = (item) => {
  return {
    type: "ON_SELECTED_QUANTITY_ITEM",
    payload: item,
  };
};

export const ON_ChangeReceipt_SELECTED_QUANTITY_ITEM = (changeReceiptItem) => {
  return {
    type: "ON_ChangeReceipt_SELECTED_QUANTITY_ITEM",
    payload: changeReceiptItem,
  };
};

export const Create_New_Receipt = (receipt) => {
  return {
    type: "Create_New_Receipt",
    payload: receipt,
  };
};

export const Change_Receipt = (changeReceipt) => {
  return {
    type: "Change_Receipt",
    payload: changeReceipt,
  };
};

export const Reset_Items = (itemsNullArray) => {
  return {
    type: "Reset_Items",
    payload: itemsNullArray,
  };
};

export const Reset_Change_Receipt_Items = (array) => {
  return {
    type: "Reset_Change_Receipt_Items",
    payload: array,
  };
};

export const Change_New_Receipt_Items = (changeReceiptItems) => {
  return {
    type: "Change_New_Receipt_Items",
    payload: changeReceiptItems,
  };
};
export const ON_Change_Database = (dbName) => {
  return {
    type: "ON_Change_Database",
    payload: dbName,
  };
};

export const Fetch_Roles_Permissions = (rolePermissions) => {
  return {
    type: "Fetch_Roles_Permissions",
    payload: rolePermissions,
  };
};
export const USER_LOGOUT = (data) => {
  return {
    type: "USER_LOGOUT",
    payload: data,
  };
};

export const SET_TREEVIEW_VISIBLE_URLS = (urls) => {
  return {
    type: "SET_TREEVIEW_VISIBLE_URLS",
    payload: urls,
  };
};

// Raw DB report menu (array of report-group DTOs) fetched once by the sidebar and shared
// so AppContainer can derive its report routes + permission map without a second API call.
export const SET_REPORT_MENU = (menu) => {
  return {
    type: "SET_REPORT_MENU",
    payload: menu,
  };
};
